import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UserProvider } from '../../providers/user';
import { LoginProvider } from '../../providers/login';

/**
 * Generated class for the CheckpinPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-checkpin',
  templateUrl: 'checkpin.html',
})
export class CheckpinPage {
  passcode:any;
  pageStatus:any;
  codeone:any;
  codetwo:any;
  codethree:any;
  codefour:any;
  codefive: any;
  codesix: any;
  int :any;
  message :any;
  finalPin :any;
  fingerPin :any;

  constructor(public loginProvider: LoginProvider, public userProvider: UserProvider, public navCtrl: NavController, public navParams: NavParams) {
      this.passcode = '';
      this.finalPin = '111111';
      this.message = true;
      this.pageStatus = "Bitte PIN eingeben"
      this.int = 0;
      this.fingerPin = false;
  }


  add(value) {
    if(this.passcode.length < 6) {
        this.passcode = this.passcode + value;
        if(this.int == 0){
            this.codeone = value;
            this.int++
        }else if(this.int == 1){
            this.codetwo = value;
            this.int++
        }else if(this.int == 2){
            this.codethree = value;
            this.int++
        }else if(this.int == 3){
            this.codefour = value;
            this.int++
        }else if(this.int == 4){
            this.codefive = value;
            this.int++
        }else if(this.int == 5){
            this.codesix = value;
            this.int++
        }
        if(this.passcode.length == 6) {
            this.loginProvider.checkPinCode(this.codeone+this.codetwo+this.codethree+this.codefour+this.codefive+this.codesix);
        }

    }
  }

  delete() {
    if(this.passcode.length > 0) {
        if(this.passcode.length == 1){
            this.codeone = null
            this.int--
        }else if(this.passcode.length == 2){
            this.codetwo = null;
            this.int--
        }else if(this.passcode.length == 3){
            this.codethree = null;
            this.int--
        }else if(this.passcode.length == 4){
            this.codefour = null;
            this.int--
        }else if(this.passcode.length == 5){
            this.codefive = null;
            this.int--
        }else if(this.passcode.length == 6){
            this.codesix = null;
            this.int--
        }
        this.passcode = this.passcode.substr(0, this.passcode.length - 1);
    }
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad CheckpinPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/checkpin/checkpin.ts